module.exports = __webpack_public_path__ + "img/Menu-12.dd823d1d.png";